<template>
  <BaseFollowupRuleDialog
    :name="name"
    :rule-holder-id="interestId"
    :dialog.sync="_dialog"
    :show-details="showDetails"
    :query-rule-gql="queryRuleGql"
    :create-rule-gql="createRuleGql"
    :update-rule-gql="updateRuleGql"
    :get-query-variables="getQueryVariables"
    :is-rule-enabled="isRuleEnabled"
    :set-rule-enabled="setRuleEnabled"
    :default-rule-data="defaultRuleData"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BaseFollowupRuleDialog from './BaseFollowupRuleDialog'
import { LIST_INTEREST_RULES, UPDATE_INTEREST_RULE, CREATE_INTEREST_RULE } from '@/backend/graphql/automationGQL'
import moment from 'moment-timezone'
import _ from 'lodash'
export default {
  name: 'InterestFollowupRuleDialog',
  components: { BaseFollowupRuleDialog },
  props: {
    name: {
      type: String,
      default: ''
    },
    dialog: {
      type: Boolean,
      default: false
    },
    showDetails: {
      type: Boolean,
      default: true
    },
    interestId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      queryRuleGql: LIST_INTEREST_RULES,
      updateRuleGql: UPDATE_INTEREST_RULE,
      createRuleGql: CREATE_INTEREST_RULE,
      defaultRuleData: {
        name: '',
        interestId: this.interestId,
        ruleType: 'STAY_IN_CONTACT',
        enabled: true,
        repeated: true,
        applyToNew: false,
        frequency: 1,
        skipContactedWithin: 0,
        eventDate: moment().format('YYYY-MM-DD'),
        applyToBirthday: true,
        applyToAll: false,
        remindDays: -1,
        scheduleTime: '08:00 am',
        timeZone: moment.tz.guess(),
        ruleMessage: [{ body: '' }]
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'account/getUser',
      allRules: 'automation/getAllRules'
    }),
    _dialog: {
      get () {
        return this.dialog
      },
      set (val) {
        this.$emit('update:dialog', val)
      }
    }
  },
  methods: {
    ...mapActions({
      updateInterestRuleByIndex: 'automation/updateInterestRuleByIndex',
      createInterestRule: 'automation/createInterestRule'
    }),
    getQueryVariables () {
      return {
        limit: 50,
        offset: 0,
        orderBy: '-id,name',
        userIds: [_.get(this.user, 'id', 0)],
        interestId: this.interestId
      }
    },
    isRuleEnabled (index) {
      const interest = _.get(this.allRules, `[${index}].interest`, [])
      return interest.filter((i) => Number(i.id) === Number(this.interestId)).length > 0
    },
    setRuleEnabled (index) {
      this.updateInterestRuleByIndex({ index, interestId: this.interestId })
    }
  }
}
</script>

<style scoped>

</style>
